import { axiosToken, simpleAxios } from "@/utils/http";
import type { AxiosResponse } from "axios";
import type { List } from "lodash";
import { defineStore, acceptHMRUpdate } from "pinia"
import { useTapasStore } from "./tapas";
import type { TapasChallenge } from "./interfaces/tapas_interfaces";
import { translate, translateAll } from "@/utils/translate";
import { useEventsStore } from "./events";
import { useContentStore } from "./content";
import { useRoute } from "vue-router";
import type { Notification } from "@/composables/useNotifications";
import dayjs from "@/utils/dayjs";
import { useChangelogStore } from "./changelog";

function stripHtml(html: string) {
	return html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim()
}

function truncate(text: string, max = 120) {
	return text.length > max ? `${text.slice(0, max)}…` : text
}

interface Booking_Item {
    id:Number,
    name:String,
    description:String,
	price?:String,
	activity:String,

}

export const useNotificationStore = defineStore("notification", {
	state: () => ({
		notifications:[],
		showDrawer: false,
	}),
	actions: {
		async fetchNotifications()
		{
			await axiosToken("get","notifications/get/").then((response)=>{
				this.notifications = response.data
				this.notifications.sort((a, b) => { return new Date(b.created_at) - new Date(a.created_at)})
			})
		},
		setNotification(id:number | string)
		{
			if (String(id).startsWith("changelog-")) {
				return
			}
			for (let i = 0; i < this.notifications.length; i++) {
				const e = this.notifications[i];
				if(parseInt(String(id)) == e.id)
				{
					e.read = true
					break;
				}
			}
		},
		setAllNotifications()
		{
			for (let i = 0; i < this.notifications.length; i++) {
				const e = this.notifications[i];
				e.read = true
			}
		}
	},
	persist: {
		// paths: ["events"]
	},
	getters:{
		getNotifications: state => (): Notification[] => {
			const result: (Notification & { sortDate: number })[] = []
			const changelogStore = useChangelogStore()

			changelogStore.unread.forEach(entry => {
				result.push({
					id: `changelog-${entry.id}`,
					category: "changelog",
					type: "success",
					title: entry.title,
					description: truncate(stripHtml(entry.body)),
					read: false,
					date: changelogStore.formatDate(entry.published_at || entry.created_at),
					isChangelog: true,
					version: entry.version || undefined,
					sortDate: new Date(entry.published_at || entry.created_at).getTime(),
				})
			})

			const notifications = JSON.parse(JSON.stringify(state.notifications))
			notifications.forEach(e => {
				result.push({
					id: e.id,
					category: e.category,
					type: e.type,
					title: e.data_html,
					description: "",
					read: e.read,
					date: dayjs(new Date(e.created_at)).format("DD/MM/YYYY HH:mm"),
					isChangelog: false,
					sortDate: new Date(e.created_at).getTime(),
				})
			})

			return result
				.sort((a, b) => b.sortDate - a.sortDate)
				.map(({ sortDate, ...item }) => item)
		},

		getUnreadNotifications: state => (): boolean => {
			const changelogStore = useChangelogStore()
			if (changelogStore.hasUnread) {
				return true
			}

			for (let i = 0; i < state.notifications.length; i++) {
				const e = state.notifications[i]
				if (!e.read) {
					return true
				}
			}
			return false
		}
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useNotificationStore, import.meta.hot))
}
